import { isUserHasKey } from '../../GlobalFunctions';
import TextInput from '../../components/TextInput';
import { FormikValues, FormikErrors } from 'formik';
import Button from '../../components/Button';
import styles from './AddStudents.module.scss';

interface FormValues {
  [key: string]: string;
}

interface Props {
  values: FormValues;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  studentNames: string[];
  handleRemoveStudent: (arg0: number) => void;
  handleAddStudent: (arg0: FormValues, arg1: (field: string, value: any, shouldValidate?: boolean) => void) => void;
  validateForm: (values?: any) => Promise<FormikErrors<FormikValues>>;
  setFieldError: (field: string, errorMsg: string) => void;
}

const AddSingleStudent = ({
  values,
  setFieldValue,
  studentNames,
  handleRemoveStudent,
  handleAddStudent,
  validateForm,
  setFieldError,
}: Props): JSX.Element => {
  const preValidateOnAdd = (values: FormValues) => {
    const { studentName, password } = values;
    if (studentName === '') {
      setFieldError('studentName', 'Please enter a student name (min 4 characters)');
      return;
    } else if (password === '') {
      setFieldError('password', 'Please enter a student password');
    } else {
      validateForm().then((errors) => {
        if (Object.keys(errors).length === 0) handleAddStudent(values, setFieldValue);
      });
    }
  };
  return (
    <>
      <TextInput label='Student Name' name='studentName' type='text' placeholder='' />
      <TextInput
        label='Student Password'
        name='password'
        type='text'
        disabled={isUserHasKey('KEY_MANAGE_STUDENTS') === null ? true : !isUserHasKey('KEY_MANAGE_STUDENTS')}
      />
      <div className={styles.buttonRow}>
        <p className={styles.noteForAddingSingleStudent}>
          Please note student passwords cannot be changed once added to your class.
        </p>
        <Button type='button' small onClick={() => preValidateOnAdd(values)}>
          ADD STUDENT
        </Button>
      </div>
      <h4 className={styles.studentBoxTitle}>Students To Add</h4>
      <div className={styles.studentBox}>
        {studentNames.length === 0 ? (
          <p className={styles.helpText}>Add a Student...</p>
        ) : (
          studentNames.map((name, index) => {
            return (
              <div key={`${name} ${index}`} className={styles.addedStudent}>
                {name}
                <button type='button' onClick={() => handleRemoveStudent(index)}>
                  x
                </button>
              </div>
            );
          })
        )}
      </div>
    </>
  );
};

export default AddSingleStudent;
